import React, { useState, useEffect } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import {
	getDiseaseGroupCompany,
	getDiseaseName,
} from "../../../services/userService";
import { pathRoot } from "../Introduction";
import { getSysInfo } from "../../../services/dashApiService";
import { contact } from "../../../configs/sysInfoConfig";
import {
	getCurrentAppVersion,
	isXamarin,
} from "../../../services/mobileService.js";
import { releaseDateLabel } from "../../../configs/config.json";

export function Page2({ onSaveFailure }) {
	const headerDetails = {
		title: "Setup Intro/Disclaimer",
		currentPage: 2,
		pageCount: 3,
	};

	const [sysInfo, setSysInfo] = useState(contact);
	useEffect(() => {
		let didCancel = false;
		getSysInfo()
			.then((result) => {
				if (result.success) {
					const data = result.data;
					if (!didCancel) {
						setSysInfo(data.contact);
					}
				} else {
					console.error(result.err);
				}
			})
			.catch((error) => {
				console.error("Error getting contact info: ", error);
			});

		return () => {
			didCancel = true;
		};
	}, []);

	const [appVersion, setAppVersion] = useState();
	useEffect(() => {
		getCurrentAppVersion()
			.then(
				(version) => {
					setAppVersion(version);
				},
				(version) => {
					console.error("Error getting app version info: ", version);
				}
			)
			.catch((error) => {
				console.error("Error getting app version info: ", error);
			});
	}, []);

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={`${pathRoot}/1`}
			nextTo={`${pathRoot}/3`}
		>
			<div className="divide-y divide-white divide-opacity-30">
				<div className="pb-2">
					<h2 className={"text-2xl font-bold mb-3"}>Contact</h2>
					<p
						className={
							"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
						}
					>
						If you need help or technical support, or wish to discuss issues
						with this Health Companion, please contact:
					</p>
					<p
						className={"mb-2.5 text-sm lg:text-base leading-tight lg:leading-6"}
					>
						<span className={"w-16 inline-block font-bold"}>Email:</span>{" "}
						<a href={`mailto:${sysInfo.email}`}>{sysInfo.email}</a>
					</p>
					<p
						className={
							"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
						}
					>
						<span className={"w-16 inline-block font-bold"}>Tel:</span>{" "}
						<a href={`tel:${sysInfo.telephone.replace(/\s+/g, "")}`}>
							{sysInfo.telephone}
						</a>
					</p>
				</div>
				<div className="py-2">
					<h2 className={"text-2xl font-bold mb-3"}>Disclaimer</h2>
					<p
						className={
							"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
						}
					>
						{getDiseaseGroupCompany()} would like to make recommendations
						representing the patient experience and circulate these to the wider{" "}
						{getDiseaseName().toLowerCase()} community and healthcare providers.
					</p>

					<p className={"mb-4 text-sm lg:text-base leading-tight lg:leading-6"}>
						We confirm that any details given in the Health Companion will be
						completely anonymised.
					</p>
				</div>
				<div className="py-2">
					<h2 className={"text-2xl font-bold mb-3"}>About</h2>
					<p
						className={"mb-2.5 text-sm lg:text-base leading-tight lg:leading-6"}
					>
						<span>{getDiseaseGroupCompany(true)} Health Companion</span>
					</p>
					{isXamarin() ? (
						<p
							className={
								"mb-2.5 text-sm lg:text-base leading-tight lg:leading-6"
							}
						>
							<span className={"w-16 inline-block "}>Version:</span>{" "}
							<span>{appVersion}</span>
						</p>
					) : releaseDateLabel ? (
						<p
							className={
								"mb-2.5 text-sm lg:text-base leading-tight lg:leading-6"
							}
						>
							<span className={"inline-block "}>Released:</span>{" "}
							<span>{releaseDateLabel}</span>
						</p>
					) : null}
					<p
						className={
							"mb-4 sm:mb-6 text-sm lg:text-base leading-tight lg:leading-6"
						}
					>
						<span>Copyright Dash Global Ltd. 2021</span>{" "}
					</p>
				</div>
			</div>
		</SetupDataPageTemplate>
	);
}
